import { render, staticRenderFns } from "./BulletinBoardTab2.vue?vue&type=template&id=6235857c"
import script from "./BulletinBoardTab2.vue?vue&type=script&lang=js"
export * from "./BulletinBoardTab2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports